<template>
  <b-container fluid>
    <b-row id="customer-summary">
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-alert show variant="primary" class="d-flex align-items-center">
              <i class="fa fa-exclamation-circle mr-2"></i>
              {{ $t('CustomerSummarySagliknetLogInfo', { service: $t('Prescription').charAt(0).toLowerCase() + $t('Prescription').slice(1), appName: 'Vega' }) }}
            </b-alert>

            <b-alert show variant="success" class="d-flex align-items-center">
              <i class="fa fa-exclamation-circle mr-2"></i>
              <span class="flex-grow-1">
                {{ $t('CustomerSummarySagliknetNewInfo', { service: $t('Prescription').charAt(0).toLowerCase() + $t('Prescription').slice(1), appName: 'Vega' }) }}
              </span>
              <b-button variant="success" size="sm" @click="pushToENabizLog">
                {{ $t('ENabizLogs') }}
              </b-button>
            </b-alert>

            <SmartDuo :key="'prescriptionLog-' + refreshKey"
                      :filterOptionsUrl="'/Sagliknet/PrescriptionLogVue'"
                      :customRenderFor="'CustomerSummary'"
                      :customerId="customerId" />
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
  import SmartDuo from '../../Pages/Shared/SmartDuo'

  export default {
    name: 'SummarySagliknet',
    props: {
      customerId: String
    },
    components: {
      SmartDuo
    },
    data() {
      return {
        refreshKey: 0
      }
    },
    watch: {
      '$route'() {
        if (this.$route.name && this.$route.name.includes('sagliknet')) {
          this.refreshKey++;
        }
      }
    },
    methods: {
      pushToENabizLog() {
        this.$router.push({
          name: 'eNabiz.logs',
          query: {
            customFilter: 'Customer',
            customFilterId: this.customerId
          }
        });
      }
    }
  }
</script>

<style>
  #customer-summary .card-body {
    padding: .5rem !important;
  }
</style>
